import React from 'react';
import { Calendar, Clock, } from 'lucide-react';
import { SAMPLE_EVENTS } from '../config/constants';

const EventsCard = () => {
  return (
    <div className="card">
      <div className="card-header">
        <Calendar size={32} className="card-icon" />
        <h2 className="card-title">Upcoming Events</h2>
      </div>

      <div className="events-list">
        {SAMPLE_EVENTS.map((event, index) => (
          <div key={index} className="event-item">
            <div className="event-details">
              <h3 className="event-title">
                {event.title}
              </h3>
              <p className="event-time">
                <Clock size={16} />
                {event.time}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EventsCard;